export const PRODUCT_LIST_PATHS = {
  // getters
  breadcrumbsGetter: "breadcrumbs/details",

  // methods
  fetchProductList: "products/fetchProducts",
  fetchFilterPanel: "products/fetchFilterPanel",
  fetchBreadcrumbs: "breadcrumbs/fetch",
  fetchConfigurableProducts: "configurableProducts/fetchProducts",
  fetchPromoterDetail: "SalePromoters/fetchPromoterDetail",
};
